export const home_tab = "xUa";
export const folder_tab = "yUa";
export const view_tab = "zUa";
export const message_tab = "AUa";
export const insert_tab = "BUa";
export const format_tab = "CUa";
export const options_tab = "DUa";
export const notes_tab = "EUa";
export const format_table_tab = "FUa";
export const poll_Button = "GUa";
export const table_Button = "HUa";
export const pictures_Button = "IUa";
export const emojis_Button = "JUa";
export const newItems_FlyoutButton = "KUa";
export const newMessage_Button = "LUa";
export const newPost_Button = "MUa";
export const newEMailMessage_Button = "NUa";
export const newCalEvent_Button = "OUa";
export const newContact_Button = "PUa";
export const newTask_Button = "QUa";
export const newTeamsMtg_Button = "RUa";
export const ignoreEmail_Button = "SUa";
export const stopIgnoringEmail_Button = "TUa";
export const cleanUp_FlyoutButton = "UUa";
export const junk_FlyoutButton = "VUa";
export const blockSender_Button = "WUa";
export const junk_Button = "XUa";
export const notJunk_Button = "YUa";
export const junkOptions_Button = "ZUa";
export const archiveEmail_Button = "_Ua";
export const sweepEmail_Button = "$Ua";
export const replyToEmail_Button = "aVa";
export const replyAllToEmail_Button = "bVa";
export const replyForwardEmail_Button = "cVa";
export const replyForwardEmailAsAttachment_Button = "dVa";
export const replyMeetingToEmail_Button = "eVa";
export const readUnread_Button = "fVa";
export const pinUnpin_Button = "gVa";
export const highImportance_Button = "hVa";
export const lowImportance_Button = "iVa";
export const sendReceiveAllFolders_Button = "jVa";
export const sendAll_Button = "kVa";
export const updateFolder_Button = "lVa";
export const showSyncProgress_Button = "mVa";
export const cancelSync_Button = "nVa";
export const workOffline_Button = "oVa";
export const downloadHeaders_Button = "pVa";
export const move_FlyoutButton = "qVa";
export const moveToOtherFolder_Button = "rVa";
export const copyToOtherFolder_Button = "sVa";
export const moveAlwaysToOtherFolder_Button = "tVa";
export const moveToNewFolderPlaceholderText = "uVa";
export const rules_FlyoutButton = "vVa";
export const createRule_Button = "wVa";
export const manageRules_Button = "xVa";
export const assignPolicy_FlyoutButton = "yVa";
export const archivePolicy1Year_button = "zVa";
export const archivePolicy5Years_button = "AVa";
export const archivePolicyNever_button = "BVa";
export const archivePolicyUseFolder_button = "CVa";
export const retentionPolicy1week_button = "DVa";
export const retentionPolicy1month_button = "EVa";
export const retentionPolicy6months_button = "FVa";
export const retentionPolicy1year_button = "GVa";
export const retentionPolicy5years_button = "HVa";
export const retentionPolicyNever_button = "IVa";
export const retentionPolicyUseFolder_button = "JVa";
export const moreRetentionPolicies_button = "KVa";
export const setFolderPolicy_button = "LVa";
export const viewExpiringItems_button = "MVa";
export const categorize_FlyoutButton = "NVa";
export const clearCategories_button = "OVa";
export const allCategories_button = "PVa";
export const setQuickCategories_button = "QVa";
export const sendReceiveGroups_Button = "RVa";
export const addReminder_Button = "SVa";
export const markComplete_Button = "TVa";
export const clearFlag_Button = "UVa";
export const setQuickClick_Button = "VVa";
export const setQuickActions_Button = "WVa";
export const addressBook_Button = "XVa";
export const readAloud_Button = "YVa";
export const getAddIns_Button = "ZVa";
export const insights_Button = "_Va";
export const reportMessage_Button = "$Va";
export const immersiveReader_Button = "aWa";
export const printMail_Button = "bWa";
export const snooze_Button = "cWa";
export const undo_Button = "dWa";
export const flagUnflag_Button = "eWa";
export const flagCompleteToday_Button = "fWa";
export const flagCompleteTomorrow_Button = "gWa";
export const flagCompleteThisWeek_Button = "hWa";
export const flagCompleteNextWeek_Button = "iWa";
export const flagCompleteNoDate_Button = "jWa";
export const flagMarkComplete_Button = "kWa";
export const flagClearFlag_Button = "lWa";
export const phishing_Button = "mWa";
export const block_Button = "nWa";
export const toggleLeftPane_Button = "oWa";
export const paste_FlyoutButton = "pWa";
export const cut_Button = "qWa";
export const copy_Button = "rWa";
export const formatPainter_Button = "sWa";
export const checkNames_Button = "tWa";
export const attachFile_FlyoutButton = "uWa";
export const attachLink_FlyoutButton = "vWa";
export const attachSig_FlyoutButton = "wWa";
export const attachSig_Button = "xWa";
export const dictate_Button = "yWa";
export const encrypt_FlyoutButton = "zWa";
export const encrypt_FlyoutTitle = "AWa";
export const encrypt_clearPermissionsButton = "BWa";
export const save_Button = "CWa";
export const sensitivity_FlyoutButton = "DWa";
export const ribbonCustomizer_Button = "EWa";
export const insertLink_Button = "FWa";
export const newNote_HeroButton = "GWa";
export const newNote_MenuButton = "HWa";
export const signatureOptions_Button = "IWa";
export const browseGroups_Button = "JWa";
export const addGroup_Button = "KWa";
export const newGroup_Button = "LWa";
export const moreRetentionPoliciesOptions_Button = "MWa";
export const viewSettings_Button = "NWa";
export const conversations_Button = "OWa";
export const messagePreview_Button = "PWa";
export const layout_Button = "QWa";
export const folder_Button = "RWa";
export const folderMenu_Show = "SWa";
export const folderMenu_Hide = "TWa";
export const density_Button = "UWa";
export const manageQuickSteps_Button = "VWa";
export const messages_Button = "WWa";
export default {home_tab,folder_tab,view_tab,message_tab,insert_tab,format_tab,options_tab,notes_tab,format_table_tab,poll_Button,table_Button,pictures_Button,emojis_Button,newItems_FlyoutButton,newMessage_Button,newPost_Button,newEMailMessage_Button,newCalEvent_Button,newContact_Button,newTask_Button,newTeamsMtg_Button,ignoreEmail_Button,stopIgnoringEmail_Button,cleanUp_FlyoutButton,junk_FlyoutButton,blockSender_Button,junk_Button,notJunk_Button,junkOptions_Button,archiveEmail_Button,sweepEmail_Button,replyToEmail_Button,replyAllToEmail_Button,replyForwardEmail_Button,replyForwardEmailAsAttachment_Button,replyMeetingToEmail_Button,readUnread_Button,pinUnpin_Button,highImportance_Button,lowImportance_Button,sendReceiveAllFolders_Button,sendAll_Button,updateFolder_Button,showSyncProgress_Button,cancelSync_Button,workOffline_Button,downloadHeaders_Button,move_FlyoutButton,moveToOtherFolder_Button,copyToOtherFolder_Button,moveAlwaysToOtherFolder_Button,moveToNewFolderPlaceholderText,rules_FlyoutButton,createRule_Button,manageRules_Button,assignPolicy_FlyoutButton,archivePolicy1Year_button,archivePolicy5Years_button,archivePolicyNever_button,archivePolicyUseFolder_button,retentionPolicy1week_button,retentionPolicy1month_button,retentionPolicy6months_button,retentionPolicy1year_button,retentionPolicy5years_button,retentionPolicyNever_button,retentionPolicyUseFolder_button,moreRetentionPolicies_button,setFolderPolicy_button,viewExpiringItems_button,categorize_FlyoutButton,clearCategories_button,allCategories_button,setQuickCategories_button,sendReceiveGroups_Button,addReminder_Button,markComplete_Button,clearFlag_Button,setQuickClick_Button,setQuickActions_Button,addressBook_Button,readAloud_Button,getAddIns_Button,insights_Button,reportMessage_Button,immersiveReader_Button,printMail_Button,snooze_Button,undo_Button,flagUnflag_Button,flagCompleteToday_Button,flagCompleteTomorrow_Button,flagCompleteThisWeek_Button,flagCompleteNextWeek_Button,flagCompleteNoDate_Button,flagMarkComplete_Button,flagClearFlag_Button,phishing_Button,block_Button,toggleLeftPane_Button,paste_FlyoutButton,cut_Button,copy_Button,formatPainter_Button,checkNames_Button,attachFile_FlyoutButton,attachLink_FlyoutButton,attachSig_FlyoutButton,attachSig_Button,dictate_Button,encrypt_FlyoutButton,encrypt_FlyoutTitle,encrypt_clearPermissionsButton,save_Button,sensitivity_FlyoutButton,ribbonCustomizer_Button,insertLink_Button,newNote_HeroButton,newNote_MenuButton,signatureOptions_Button,browseGroups_Button,addGroup_Button,newGroup_Button,moreRetentionPoliciesOptions_Button,viewSettings_Button,conversations_Button,messagePreview_Button,layout_Button,folder_Button,folderMenu_Show,folderMenu_Hide,density_Button,manageQuickSteps_Button,messages_Button};